<template>
  <div class="link-views white-bg">
    <div class="top">
      <span style="display:none;">{{isExpID}}</span>
      <router-link :to="{name:this.$route.params.sub,params:{id:ExpID}}">
        <Button class="mr" type="primary">返回</Button>
      </router-link>
    </div>
    <div class="reportList">
      <div v-if="editItem.IsReview">

          <div v-for="(item,index) in arr" :key="index">
            <div class="title">
              <strong>{{item.title}}</strong>
            </div>
            <div class="m10">
              <div class="showDetails" v-html="editItem[item.name]" v-if="editItem[item.name]"></div>

              <div v-else>暂无数据</div>
            </div>
            <div class="info report m10" v-if="item.isReport">
              点评：
              <span v-if="editItem[item.Reportname]">{{editItem[item.Reportname]}}</span>
              <span v-else>暂无点评</span>
            </div>
          </div>

        <div style="maring:20px 0;padding-bottom:40px;">
          <strong class="mr">报告得分</strong>
          <span class="report">{{editItem.ExpReportScore?editItem.ExpReportScore:0}}</span>
        </div>
      </div>
      <div v-else>
        <div v-for="(item,index) in arr" :key="index">
          <div class="title">
            <strong>{{item.title}}</strong>
          </div>
          <div v-if="item.isReport">
            <div v-if="item.IsSubmit">
              <strong>{{editItem[item.name]}}</strong>
            </div>
            <div v-else class="m10">
              <editorElem
                :catchData="val=>catchData(val,item.name)"
                :content="submitObj[item.name]"
              ></editorElem>
            </div>
          </div>
          <div class="info" v-else style="padding:10px 0;">
            <strong v-if="editItem[item.name]">{{editItem[item.name]}}</strong>
            <strong v-else>暂无数据</strong>
          </div>
        </div>

        <div class="text-right p10">
          <Button class="mr" type="primary" @click="submintReport(0)">保存</Button>
          <Button type="primary" @click="submintReport(1)">提交</Button>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import * as homeApi from "../../../api/student-api.js";

import editorElem from "../../../components/Editor";
export default {
  name: "labReport",
  components: {
    editorElem
  },
  data() {
    return {
      ExpID: 0, //当前所属实验ID
      IsSubmit: 0,
      arr: [
        {
          title: "一、实验目的",
          name: "ExpMD",
          isReport: false
        },
        {
          title: "二、实验原理",
          name: "ExpYL",
          isReport: false
        },
        {
          title: "三、实验要求",
          name: "ExpRequire",
          isReport: false
        },
        {
          title: "四、实验考核标准",
          name: "ExpStandard",
          isReport: false
        },
        {
          title: "五、实验材料（整个综合实验有涉及到的材料都要列出）",
          name: "ExpMaterials",
          Reportname: "ExpMaterialsR",
          isReport: true
        },
        {
          title: "六、实验步骤（详叙每周所做的相关步骤）",
          name: "ExpStep",
          Reportname: "ExpStepR",
          isReport: true
        },
        {
          title: "七、实验数据与记录",
          name: "ExpData",
          Reportname: "ExpDataR",
          isReport: true
        },
        {
          title: "八、实验结果与总结",
          name: "ExpResult",
          Reportname: "ExpResultR",
          isReport: true
        }
      ],
      editItem: {},
      submitObj: {}
    };
  },
  mounted() {
    this.ExpID = this.$route.params.id;
     this.GetExpReport(this.ExpID);
  },
  watch: {
    ExpID(val) {
        this.GetExpReport(this.ExpID);
    }
  },
  computed: {
    isExpID() {
      this.ExpID = this.$route.params.id;
      return this.$route.params.id;
    }
  },
  methods: {
    // 提交或保存报告
    GetExpReport(ExpID) {
      homeApi.GetExpReport({ ExpID: this.ExpID }).then(res => {
        this.editItem = res;
        this.IsSubmit = res.IsSubmit;
        this.submitObj = {
          ExpID: res.ExpID,
          ExpMaterials: res.ExpMaterials,
          ExpStep: res.ExpStep,
          ExpData: res.ExpData,
          ExpResult: res.ExpResult,
          IsSubmit: 0
        };
      });
    },
    submintReport(num) {
      this.submitObj.IsSubmit = num;
      homeApi.SubmitRe(this.submitObj).then(res => {
        if (res.success) {
          this.$Message.success({
            content: res.msg,
            duration: 3
          });
          this.$router.push({
            name: this.$route.params.sub,
            params: { id: this.ExpID }
          });
        } else {
          this.$Message.error({
            content: res.msg,
            duration: 3
          });
        }
      });
    },
    catchData(val, str) {
      this.submitObj[str] = val;
    }
  }
};
</script>

<style scoped>
li {
  list-style: none;
}
</style>